
const Text = () => {
    return (
        <article>
            <h4>When was the last time you took a day to yourself?</h4>
            <p>Like sleeping, eating, and breathing, self-care should be a priority rather than something we push to the bottom of our to-do list. This is your gratitude to yourself.</p>
            <p className='quote'><q>Self-care is how you take your power back.</q> &#8210; Lalah Delia</p>
        </article>
    );
}
export default Text;